module.exports = __webpack_public_path__ + "img/成品试穿ico.bed659da.png";